export const secondaryColors = {
  // ---- BRAND / PRIMARY ACCENT ----
  primary: {
    DEFAULT: '#7A54F7',
    foreground: '#FFFFFF',
    hover: '#412C83',
    active: '#5D40BD',
    subtle: '#D5C4FF',
    subtleHover: '#F5F2FF',
  },

  // ---- APPLICATION BACKGROUNDS ----
  background: {
    base: '#101014', // global app bg
    surface: '#15161E',
    raised: '#1A1C25',
  },

  // ---- NEUTRALS / TEXT / BORDERS ----
  neutral: {
    100: '#E6E7F0', // main text
    200: '#C5C7D5',
    300: '#848694',
    400: '#252630', // borders
    500: '#1B1D24',
    600: '#14151B',
    black: '#000000',
    numeric: '#A0A5B4',
  },

  // ---- SEMANTIC COLORS (PASTEL, MATCH DARK PURPLE UI) ----
  success: {
    DEFAULT: '#40C89A',
    numeric: '#7ADDBC',
    cardBg: '#161D1E',
  },

  danger: {
    DEFAULT: '#E57373',
    numeric: '#F4A8A8',
    cardBg: '#1E181C',
  },

  warning: {
    DEFAULT: '#F4C76E',
    numeric: '#F8DFA7',
    cardBg: '#191919',
  },

  info: {
    DEFAULT: '#8B8CFF',
    numeric: '#B5B6FF',
    cardBg: '#171621',
    subtle: '#1F1A34', // bg for tooltips
  },

  // ---- ADDITIONAL ACCENTS ----
  accent: {
    violet: '#5D40BD', // redirections out of app
    yellow: '#F4C76E', // cex badge
    purple: '#C5A0FF', // custodian badge
    blue: '#57A8FF', // liquidity provider badge
  },

  // ---- CHART COLORS ----
  chart: ['#7A54F7', '#3E6BFF', '#1BC4C4', '#C540BD', '#A3B1C6'],

  // ---- PIE CHART COLORS ----
  pieChart: [
    '#7A54F7',
    '#8C6BFF',
    '#A085FF',
    '#B59EFF',

    '#5D40BD',
    '#4A3FA5',
    '#3E6BFF',
    '#4A8BFF',
    '#57A8FF',

    '#1BC4C4',
    '#27D6C6',
    '#40E6C8',
    '#6FFFD7',

    '#40C89A',
    '#5CDD9F',
    '#8BF4B8',

    '#F4C76E',
    '#F8DFA7',
    '#FFB870',
    '#E57373',
  ],
};
